export default __webpack_public_path__ + "static/media/dsm-unselected.8031ea4b.png";